import { ResultItem } from '../resultItem/ResultItem';
import { Pagination } from '../pagination/Pagination';
import { SkeletonResultList } from '../skeletonResultList/SkeletonResultList';
import { Filters, ResultItem as ResultItemType } from '@/domain';

type ResultListMapProps = {
    stats: Record<string, unknown>;
    filters: Filters;
    onFilterChanged: (filters: Filters) => void;
    isMobile: boolean;
    numberOfPreloadedImages: number;
    results: ResultItemType[] | false;
    loginId?: number;
};

export const ResultListMap = ({
    results,
    filters,
    numberOfPreloadedImages,
    loginId,
    isMobile,
    stats,
    onFilterChanged,
}: ResultListMapProps) => {
    const renderItemNodes = () =>
        (results as ResultItemType[]).map((item, index) => (
            <ResultItem
                key={`${item.id}_${index}`}
                index={index}
                result={item}
                filters={filters}
                imagePreloaded={index < numberOfPreloadedImages}
                loginId={loginId}
                isMobile={isMobile}
            />
        ));

    const renderItemsAndPagination = () => (
        <>
            <section className="grid grid-cols-2 gap-8" aria-labelledby="ads-heading" id="ads" data-testid="resultList">
                <h1 className="sr-only" id="ads-heading">
                    Søkeresultater
                </h1>
                {renderItemNodes()}
            </section>
            <Pagination stats={stats} onFilterChanged={onFilterChanged} />
        </>
    );

    const renderFetchFailedMessage = () => (
        <p className="pal u-t3 u-align-centerify" data-testid="fetchFailed">
            Noe gikk galt under henting av tilbud. <a href="">Prøv å laste siden på nytt.</a>
        </p>
    );

    const renderNoResultsMessage = () => (
        <p className="pal u-t3 u-align-centerify" data-testid="emptyResultList">
            Ingen treff akkurat nå. Zoom ut i kartet for å få flere treff.
        </p>
    );

    if (results === null) {
        return <SkeletonResultList isMobile={isMobile} />;
    } else if (results === false) {
        return renderFetchFailedMessage();
    } else if (results.length === 0) {
        return renderNoResultsMessage();
    } else {
        return renderItemsAndPagination();
    }
};

ResultListMap.defaultProps = {
    results: [],
    stats: {},
};
